<template>
<div class="chapter">
<div class="inner_page">
<h2 class="CN" id="pt2"><a href="#/text/9780062365606_Contents#rpt2">part two</a></h2>
<p class="Part-headings_PTO1_Part_title_2"><span class="small"><a href="#/text/9780062365606_Contents#rpt2">FRANCE</a></span></p>
<p class="FME1_Frontmatter_epigraph_other_1 ParaOverride-7">‘And at home by the fire, whenever you look up there I shall be – and whenever I look up there will be you.’</p>
<p class="FME1_Frontmatter_epigraph_other_1 ParaOverride-8">Her countenance fell, and she was silent awhile.</p>
<p class="FME2_Frontmatter_epigraph_other_2 _idGenParaOverride-1">Thomas Hardy, <i>Far From the Madding Crowd</i>           </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062365606_Part_2.vue?0fa63597